import React from 'react';

class Login extends React.Component {

  render() {
    return (
      <div className="Login">
        <button onClick={this.props.authenticate}>Login with Github!</button>
      </div>
    );
  }
}

export default Login;
